import React, { useState } from "react";
import {
    Box, Button,
    Dialog, DialogActions, DialogContent, DialogTitle,
    FormControl, FormHelperText,
    InputLabel, MenuItem, OutlinedInput, Select, TextField
} from "@mui/material";

import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { formatDate } from "../../../../utilities/formatters";

function StatusDialog({ open, onSave, onClose, data = {}, ...props }) {
    const [status, setStatus] = useState(data.status || "");
    const [notes, setNotes] = useState(data?.notes || "");
    const [dateEnd, setDateEnd] = useState(data?.dateEnd || "");

    const onSubmit = () => {
        const params = {
            status,
            dateEnd: formatDate(dateEnd),
            notes,
        };
        onSave(params);
        onClose();
    };

    const options = [
        ...new Set([...(data?.options || []), data?.status].filter(Boolean)),
    ];

    return (
        <Dialog open={open} onClose={onClose} fullWidth={true} maxWidth="sm">
            <DialogTitle>Development need</DialogTitle>
            <DialogContent dividers={false}>
                <Box
                    component="form"
                    autoComplete="off"
                    noValidate
                    className="dialog-content"
                    onSubmit={(e) => e.preventDefault()}
                >
                    {options?.length > 0 && (
                        <FormControl component="div" fullWidth={true} autoFocus>
                            <InputLabel id="status-label" sx={{ backgroundColor: "#FFF", padding: "0 4px" }}>
                                Status
                            </InputLabel>
                            <Select
                                id="select-status"
                                value={status}
                                onChange={({target}) => setStatus(target.value)}
                            >
                                {options.map((option) => (
                                    <MenuItem value={option} key={option}>
                                        {option.charAt(0).toUpperCase() + option.slice(1)}
                                    </MenuItem>
                                ))}
                            </Select>
                            <FormHelperText>Select a status</FormHelperText>
                        </FormControl>
                    )}

                    {(status === "deferred" || status === "cancelled" || status === "completed") && (
                        <FormControl
                            component="div"
                            margin="normal"
                            required
                            error={!dateEnd}
                        >
                            <DatePicker
                                label="Date"
                                value={dayjs(dateEnd)}
                                inputFormat="DD/MM/YYYY"
                                onChange={setDateEnd}
                                renderInput={(params) => <TextField {...params} />}
                            />
                        </FormControl>
                    )}

                    {(status === "deferred" || status === "cancelled") && (
                        <FormControl
                            component="div"
                            fullWidth
                            margin="normal"
                        >
                            <OutlinedInput
                                value={notes}
                                onChange={({target}) => setNotes(target.value)}
                                placeholder="Comments"
                                multiline
                                rows={2}
                            />
                            <FormHelperText>Add comments here</FormHelperText>
                        </FormControl>
                    )}
                </Box>
            </DialogContent>
            <DialogActions>
                <Button key="cancel" onClick={onClose}>
                    Cancel
                </Button>
                {options?.length > 0 && (
                    <Button
                        key="save"
                        variant="contained"
                        color="primary"
                        disableElevation={true}
                        onClick={onSubmit}
                        disabled={!status}
                    >
                        Save
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
}

export default StatusDialog;
